enum UserTypeEnum {
  "USER" = "USER",
  "ADMIN" = "ADMIN",
  "SUPERADMIN" = "SUPERADMIN",
}

export default UserTypeEnum;
